import { gql } from '@apollo/client';

export const GET_MISSING_COURSE_REPORTS = gql`
query GetMissingCourseReports {
    getMissingCoursesReport {
      indexNumber
      name
      missingCourses {
        courseId
        courseName
        courseCode
      }
    }
  }
`;


export const RESOLVE_MISSING_COURSE_REPORT = gql`
  mutation ResolveMissingCourseReport($indexNumber: String!) {
  resolveMissingCourseReport(indexNumber: $indexNumber) {
    status
    message
  }
}
`;